<template>
  <el-container class="grey-bg">
    <el-header class="p0">
      <div class="header">
        <div class="type-center header-e p10">
          <div class="logo pointer" @click="routerGo('/')">
            <img src="@/assets/slices/Group33.png" alt/>
          </div>
          <div class="flex al-cn ju-sa white-color pointer" style="min-width: 256px;font-size: 11pt">
            <div v-if="!token" class="discolour-golden" @click="routerGo('/?name=注册',)">考生注册</div>
            <div v-if="!token" class="discolour-golden" @click="routerGo('/?name=登录',)">考生登录</div>
            <div class="discolour-golden" @click="routerGo('/aboutUs/examPoint')">考点申请</div>
            <div class="flex al-cn" v-if="token" @click="routerGo('/userCenter')">
              <el-avatar size="large" :src="circleUrl"></el-avatar>
              <div class="ml10 discolour-golden">{{ userInfo.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="white-bg">
        <div class="type-center menu-e">
          <el-menu
              :default-active="defaultActive"
              class="menu-a p0"
              mode="horizontal"
              active-text-color="#C32912"
              text-color="#333333"
              @select="handleSelect"
              @open="handleOpen"
              :menu-trigger="menuTrigger"
              ref="menu"
              :router="router">
            <el-row class="menuItem">
              <el-menu-item index="/home">网站首页</el-menu-item>
              <el-submenu index="/examinationAndRegistration">
                <template slot="title">考试与报名</template>
                <el-menu-item index="/examinationAndRegistration/introduce">考试介绍</el-menu-item>
                <el-menu-item index="/examinationAndRegistration/outline">考试大纲</el-menu-item>
                <el-menu-item index="/examinationAndRegistration/signUp">考试报名</el-menu-item>
                <el-menu-item index="/examinationAndRegistration/scoreInquiry">成绩查询</el-menu-item>
                <el-menu-item index="/examinationAndRegistration/certificateQuery">证书查询</el-menu-item>
                <el-menu-item index="/examinationAndRegistration/testSiteQuery">考点查询</el-menu-item>
              </el-submenu>
              <el-submenu index="/latestNews">
                <template slot="title">最新资讯</template>
                <el-menu-item index="/latestNews/examNotice/list">考试通知</el-menu-item>
                <el-menu-item index="/latestNews/newsInformation/list">新闻资讯</el-menu-item>
                <el-menu-item index="/latestNews/testSiteInformation/list">活动公告</el-menu-item>
                <el-menu-item index="/latestNews/lecture/list">学术交流</el-menu-item>
<!--                <el-menu-item index="/latestNews/cooperation/list">国际合作</el-menu-item>-->
              </el-submenu>
              <el-submenu index="/internship">
                <template slot="title">实习实践</template>
                <el-menu-item index="/internship/overseasInternship/list">实习实践项目</el-menu-item>
                <el-menu-item index="/internship/internationalChinese/list">实习实践动态</el-menu-item>
                <el-menu-item index="/internship/employment/list">就业及升学</el-menu-item>
              </el-submenu>
              <el-submenu index="/resourceCenter">
                <template slot="title">资源中心</template>
                <el-menu-item index="/resourceCenter/textbook/list">教材教辅</el-menu-item>
                <el-menu-item index="/resourceCenter/freeCourse/list">免费课程</el-menu-item>
                <el-menu-item index="/resourceCenter/examSample/list">考试样题</el-menu-item>
                <el-menu-item index="/resourceCenter/addition/list">加试说明</el-menu-item>
              </el-submenu>
              <el-submenu index="/aboutUs">
                <template slot="title">关于我们</template>
                <el-menu-item index="/aboutUs/platformIntroduction">主办机构</el-menu-item>
                <el-menu-item index="/aboutUs/contactUs">联系我们</el-menu-item>
                <el-menu-item index="/aboutUs/examPoint">考点申请</el-menu-item>
                <el-menu-item index="/aboutUs/copyright">版权申明</el-menu-item>
                <el-menu-item index="/aboutUs/memberTerms">会员条款</el-menu-item>
                <el-menu-item index="/aboutUs/complaint">投诉建议</el-menu-item>
              </el-submenu>
            </el-row>
          </el-menu>
          <div class="login-button pointer flex al-cn" @click="routerGo('/search')">
            <el-input class="input" placeholder="输入关键字" v-model="input" readonly>
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <div class="but">
              搜索 <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </el-header>
    <el-main>
      <div class="type-center">
        <router-view></router-view>
      </div>
    </el-main>
    <div class="footer f15" v-show="isShow">
      <div class="bgC32912 white-color p17">
        <div class="flex al-cn friendlyLink type-center">
          <div class="friendlyLink_title flex-shrink-0">友情链接：</div>
          <div class="flex al-cn war-pe friendlyLink_item">
            <div class="friendlyLink_a discolour-golden" @click="skipExtranet('https://www.cipgtraining.org/')">
              中国外文局教育培训中心
            </div>
            <div class="friendlyLink_a discolour-golden" @click="skipExtranet('http://www.chinalanguage.org/')">
              国际汉语教育网
            </div>
            <div class="friendlyLink_a discolour-golden" @click="skipExtranet('https://www.uibe.edu.cn/')">
              对外贸易经济大学
            </div>
            <div class="friendlyLink_a discolour-golden"
                 @click="skipExtranet('https://www.sinolingua.com.cn/index.php')">
              华语教学出版社
            </div>
            <div class="friendlyLink_a discolour-golden" @click="skipExtranet('https://www.hwjyw.com/')">
              华文教育网
            </div>
            <div class="friendlyLink_a discolour-golden"
                 @click="skipExtranet('http://www.china-language.edu.cn/#/index')">
              中国语言文字网
            </div>
          </div>
        </div>
      </div>
      <div class="type-center flex ju-cn war-pe mt40 pointer cl333 f15">
        <div class="mlr30 mb10 discolour" @click="routerGo('/')">网站首页</div>
        |
        <div class="mlr30 mb10 discolour" @click="routerGo('/aboutUs/platformIntroduction')">平台简介</div>
        |
        <div class="mlr30 mb10 discolour" @click="routerGo('/aboutUs/copyright')">版权声明</div>
        |
        <div class="mlr30 mb10 discolour" @click="routerGo('/aboutUs/memberTerms')">会员条款</div>
        |
        <div class="mlr30 mb10 discolour" @click="routerGo('/aboutUs/complaint')">投诉建议</div>
        |
        <div class="mlr30 mb10 discolour" @click="routerGo('/aboutUs/contactUs')">联系我们</div>
      </div>
      <div class="flex ju-cn war-pe cl666 f12 mt10">
        <div class="mlr30 mb10">版权所有：中国外文局教育培训中心</div>
        <div class="mlr30 mb10">网站运维：北京雅言通教育科技有限公司</div>
        <div class="mlr30 mb10">联系电话：010-6266 6860</div>
      </div>
      <div class="flex ju-cn f12 mb20">
        <a class="cl666" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
          京ICP备10018251号-3
        </a>
      </div>
    </div>
  </el-container>
</template>

<script>
import {mapState} from 'vuex'

export default {
  data() {
    return {
      router: true,
      //路由激活
      defaultActive: "/Home",
      home: true,
      isShow: true,
      input: '',
      menuTrigger: document.body.clientWidth < 750 ? 'click' : 'hover',
      activeIndex: '',
      circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
    };
  },
  computed: {
    ...mapState(['token', 'userInfo']),
  },
  watch: {
    $route(val) {
      this.defaultActive = val.fullPath;
      this.home = this.defaultActive === '/Home';
    }
  },
  mounted() {
    this.defaultActive = this.$route.fullPath;
    this.home = this.defaultActive === '/Home';
  },
  methods: {
    // 菜单选择
    handleSelect(key) {
      this.home = key === '/Home';
    },
    // 菜单展开
    handleOpen(key) {
      this.$refs.menu.close(this.activeIndex);
      this.activeIndex = key;
    },
    //路由跳转
    routerGo(path, name) {
      console.log('路由跳转', path)
      if (path && path !== this.$route.fullPath) {
        this.$router.push({
          path: path,
          /*query: {
            name: name
          }*/
        });
      }
    },
    // 跳转外网
    skipExtranet(url) {
      // 跳转外网并打开新窗口
      window.open(url);
    },
    loginIn() {
      this.$router.push({path: "/login"});
    },
  }
};
</script>

<style lang="scss">
.el-header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;

  .logo {
    max-width: 725px;
    //height: 91px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .login-button {
    .input {
      width: 320px;
    }

    .but {
      width: 100px;
      height: 40px;
      line-height: 40px;
      background: #C32912;
      border-radius: 0 56px 56px 0;
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
      text-align: center;
    }
  }
}

.header {
  background-image: url("../assets/slices/Group17.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.footer {
  width: 100%;
  overflow: hidden;
  background-color: #fff;
}

.menuItem {
  display: grid; /* 使用 Grid 布局 */
  grid-auto-flow: column; /* 子元素按列排列 */
  width: 100%;
  overflow-x: auto; /* 内容超出宽度时显示水平滚动条 */
}

@media (max-width: 750px) {
  .el-header {
    .logo img {
      width: 93%;
      height: 100%;
      margin-bottom: 5px;
    }

    .login-button {
      margin-top: 7px;

      .but {
        width: 80px;
        font-size: 14px;
      }

      .input {
        width: 65%;
        margin-left: 15px;
      }
    }
  }
  .menu-e {
    padding-bottom: 7px;
  }
  .menu-a > .menuItem {
    .el-menu-item {
      height: 45px;
      line-height: 45px;
      font-size: 13px;
      padding: 0 8px;
      cursor: pointer;
    }
  }

  .menu-a > .menuItem {
    .el-submenu {
      .el-submenu__title {
        height: 45px;
        line-height: 45px;
        font-size: 13px;
        padding: 0 8px;
        cursor: pointer;
      }

      .el-submenu__icon-arrow {
        //margin-left: 1px;
        //隐藏
        //display: none;
      }
    }
  }

  .el-main {
    padding: 0 !important;
    margin-top: 220px;
  }

  .friendlyLink {
    &_title {
      min-width: 75px;
    }

    &_item {
      margin-bottom: -10px;
    }

    &_a {
      margin-left: 20px;
      margin-bottom: 10px;
    }
  }

}

@media (min-width: 750px) {
  .header-e {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .menu-e {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .el-main {
    padding: 0 !important;
    margin-top: 190px;
  }
  .friendlyLink {
    justify-content: space-between;

    &_item {
      width: 1070px;
      justify-content: space-between;
    }
  }
}
</style>
